<div class="container">
  <!--<div class="text-center" style="margin-top:8%; font-size: 1.8em; font-weight:bold; color:red">Claims Filing Has Ended</div>-->
  <h4 class="misc-titles text-center mt-4">Thank you for visiting the Fix My Claim portal<br /> for the Nelnet Data Security Settlement.</h4>
  <div class="containerLogin login-container">
    <form [formGroup]="loginInformation" (ngSubmit)="onSubmit()">
      <div class="row mt-5">
        <div class="col-md-3"></div>
        <div class="col-md-6 login-form-1">

          <p class="misc-titles text-center">
            To Fix your claim, please provide the Claim Number listed on the Notice that was sent to you:.
          </p>
          <div class="form-group">
            <label for="claimNumber">Claim Number: <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="claimNumber" trim="blur" autocomplete="off"
                   [ngClass]="{ 'is-invalid': submitted && f.claimNumber.errors }" />
            <div *ngIf="submitted && f.claimNumber.errors" class="invalid-feedback">
              <div *ngIf="f.claimNumber.errors.required">This field is required</div>
              <div *ngIf="f.claimNumber.errors.minlength">This field must be at least 9 digits</div>
              <div *ngIf="f.claimNumber.errors.maxlength">
                This field must not be at greater 10 digits
              </div>
              <div *ngIf="f.claimNumber.errors.pattern">This field accepts only numerical digits 0-9</div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-center">
              <div class="form-group">
                <button class="btn btn-primary" id="login" [disabled]="clicked">Login</button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3"></div>
      </div>
    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
  </div>
</div>

